<template>
  <span :class="brandClasses.badge">
    <template v-if="icon">
      <img v-if="badges[icon]" alt="" :src="badges[icon]" :style="`height: ${size};`">
      <vf-icon v-else :name="icon" :size="iconSize" />
    </template>
    {{ label }}
  </span>
</template>

<script lang="ts" setup>
import type { BadgeItem } from '#types/product'
import { filename } from 'pathe/utils'

const { icon } = defineProps<BadgeItem>()

const { brandClasses, iconSize } = useAppConfig().components.product.badge
const { size: sizes } = useAppConfig().components.vf.icon

const size = computed(() => pxToRem(sizes[iconSize]))

const glob = import.meta.glob<string>('@brand/assets/badges/*.svg', { eager: true, import: 'default' })
const badges = Object.fromEntries(Object.entries(glob).map(([key, value]) => [filename(key), value]))

if (icon && !badges[icon]) {
  log.error(`
    Product/Badge: There is no local file present for ${icon}.
    No icon will be displayed.
    Please, check if your configuration is correct
  `)
}
</script>
